import isServer from 'src/common/utils/isServer';
import type { AppServices } from './types';

let clientAppServices: AppServices | null = null;

/** Registers the browser's services. Called once, when the client starts. */
export function setClientAppServices(services: AppServices) {
  clientAppServices = services;
}

/**
 * Returns the browser's services for code outside React, such as the player or ads. Code that runs
 * during server rendering must receive the services as an argument instead, so this throws there.
 */
export function getClientAppServices(): AppServices {
  if (isServer()) {
    throw new Error('getClientAppServices is client-only; pass the services in during SSR');
  }

  if (!clientAppServices) {
    throw new Error('getClientAppServices called before the client registered its services');
  }

  return clientAppServices;
}
